import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function NeoModal({ size='small', children, className, onHide=()=>{} }) {
    return (
        <Modal
            show={true}
            size={size}
            dialogClassName={className}
            onHide={onHide}
        >
            <Modal.Body>
                {children}
            </Modal.Body>
        </Modal>
    );
}

NeoModal.defaultProps = {
    size: null
}

NeoModal.propTypes = {
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
    size: PropTypes.string,
    className: PropTypes.string
};
